import setTitleAndMetaDescription from "../setTitleAndMetaDescription.tsx";

export default function AlternativeFrontpagesTitleAndMetaDescription() {
    setTitleAndMetaDescription(
        'Få 99 kr fibernet de første 6. mdr.',
        'Afhængigt af din adresse kan du få lynhurtigt fibernet for 99 kr de første 6 mdr. Hop ind på Hiper for at se, om du kan få den knivskarpe pris.'
    )
}
